module.exports = __webpack_public_path__ + "img/logo.c134d8e5.png";